let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3NjjI")).then(() => parcelRequire('7taCN'));